var exports = {
  "rf": "body__p7eKCf",
  "h_": "description__hSMFt9",
  "LO": "descriptionHandle__BO6kyd",
  "ci": "textareaContainer__8KZAUG",
  "C1": "instructionsTextarea__d5AhFw",
  "C7": "textareaToolbar__644eic",
  "Ff": "errorRow__PxiEyP",
};

module.exports = exports;
